import React, { useState, useEffect } from "react";
import ActivityCard from "../../components/ui/newActivityCard.js";
import RequestSummaryCard from "../../components/RequestsComponents";
import "../../assets/styles/AdminRequests.css";
import { activitiesRequestsAPI } from "../../services/userService.js";
import { useNavigate } from "react-router-dom";

const AdminRequestsPage = ({ user }) => {
  const [activeTab, setActiveTab] = useState("activities");
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });

  // خلي القيمة المبدئية للأعداد 0 عشان الشكل يكون حلو لحد ما يحمل
  const [count, setCount] = useState({ activities: 0, roles: 0, profile: 0 });

  const navigate = useNavigate();

  const fetchRequests = async (type, page) => {
    try {
      setLoading(true);
      const result = await activitiesRequestsAPI(type, page);

      if (result?.data) {
        setRequestData(result?.data?.items || []);
        // تحديث العدادات دايماً
        if (result?.data?.counts) {
          setCount(result.data.counts);
        }
        setPagination({
          page: result.data.pagination.currentPage,
          totalPages: result.data.pagination.totalPages,
        });
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests(activeTab, pagination.page);
  }, [activeTab, pagination.page]);

  //  التعديل الأول: منع إعادة التحميل لو ضغطنا على نفس التاب
  const handleTabChange = (tabName) => {
    if (activeTab === tabName) return; // لو هو هو، اخرج فوراً ومتعملش حاجة

    setActiveTab(tabName);
    setPagination({ ...pagination, page: 1 });
    setRequestData([]);
  };

  const handleViewDetails = (id) => {
    navigate(`/admin/request-details/${id}?type=${activeTab}`);
  };

  return (
    <div className="admin-requests-container mt-5 py-5">
      <div className="container">
        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <h2 className="fw-bold text-dark">Requests Management</h2>
            <p className="text-muted">
              Manage activities, role upgrades, and profile updates.
            </p>
          </div>
        </div>

        {/*  التعديل الثاني: تحسين شكل التابات والعدادات */}
        <div className="custom-tabs">
          <button
            className={`tab-btn ${activeTab === "activities" ? "active" : ""}`}
            onClick={() => handleTabChange("activities")}
          >
            Activity Requests
            {/* يظهر العداد فقط لو الرقم أكبر من صفر */}
            {count?.activities > 0 && (
              <span className="count-badge">{count.activities}</span>
            )}
          </button>

          <button
            className={`tab-btn ${activeTab === "roles" ? "active" : ""}`}
            onClick={() => handleTabChange("roles")}
          >
            Role Changes
            {count?.roles > 0 && (
              <span className="count-badge">{count.roles}</span>
            )}
          </button>

          <button
            className={`tab-btn ${activeTab === "profile" ? "active" : ""}`}
            onClick={() => handleTabChange("profile")}
          >
            Profile Updates
            {count?.profile > 0 && (
              <span className="count-badge">{count.profile}</span>
            )}
          </button>
        </div>

        {/* Content Area */}
        <div className="row g-4">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-2 text-muted">Loading requests...</p>
            </div>
          ) : requestData.length > 0 ? (
            <>
              {/* Activities Grid */}
              {activeTab === "activities" &&
                requestData.map((activity) => (
                  <div key={activity._id} className="col-12 col-md-6 col-lg-4">
                    <ActivityCard
                      _id={activity?._id}
                      activityName={activity?.activityName}
                      posterImage={activity?.posterImage}
                      capacity={activity?.capacity}
                      participantsCount={activity?.participantsCount}
                      supervisorID={activity?.supervisorID}
                      participants={activity?.participants || []}
                      currentUserId={user?._id}
                      role={user?.role}
                      flags={activity?.flags}
                      type={activity?.type}
                    />
                  </div>
                ))}

              {/* Roles & Profile List */}
              {(activeTab === "roles" || activeTab === "profile") && (
                <div className="col-12 col-lg-10 mx-auto">
                  {requestData.map((item) => (
                    <RequestSummaryCard
                      key={item._id}
                      data={item}
                      onViewDetails={handleViewDetails}
                    />
                  ))}
                </div>
              )}
            </>
          ) : (
            // Empty State
            <div className="text-center py-5">
              <h5 className="text-muted">
                No pending requests found for {activeTab}.
              </h5>
              <p className="small text-secondary">
                Good job! You're all caught up.
              </p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {!loading && requestData.length > 0 && pagination.totalPages > 1 && (
          <div className="d-flex justify-content-center mt-5 gap-2">
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={pagination.page === 1}
              onClick={() =>
                setPagination((prev) => ({ ...prev, page: prev.page - 1 }))
              }
            >
              Previous
            </button>
            <span className="align-self-center px-2 text-muted">
              Page {pagination.page} of {pagination.totalPages}
            </span>
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={pagination.page === pagination.totalPages}
              onClick={() =>
                setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
              }
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminRequestsPage;
